import { useState } from "react";
import styles from "./inlineEdit.css";

function InlineEdit({ name, id, value: initialValue, onBlur }) {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState();

  function handleChange(event) {
    setValue(event.target.value);
  }

  function handleKeyDown(event) {
    if (event.key === "Escape") {
      setValue(initialValue);
      event.target.blur();
    }

    if (event.key === "Enter") {
      event.target.blur();
    }
  }

  function handleFocus(event) {
    event.target.select();
  }

  async function handleBlur() {
    const currentValue = value.trim();

    setError(null);

    if (currentValue === "" || currentValue === initialValue) {
      setValue(initialValue);
      return;
    }

    try {
      await onBlur(currentValue);
    } catch (err) {
      setError(err);
    }
  }

  return (
    <div className={styles.control[error ? "error" : "default"]}>
      <input
        type="text"
        name={name}
        id={id}
        title="Wert ändern"
        className={styles.input}
        aria-label={name}
        value={value}
        onFocus={handleFocus}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        size={value.length || 8}
      />

      {error && <p className={styles.error}>{error?.message || error}</p>}
    </div>
  );
}

export default InlineEdit;
